<label class="primary-color-row">
    <span class="primary-color-swatch" [style.background-color]="primaryColor">
        <input
            type="color"
            [value]="primaryColor"
            (input)="onColorInput($event)"
            aria-label="Pick primary color" />
    </span>
    <span class="primary-color-picker-label">Primary color</span>
    @if (isCustomColor) {
        <button
            type="button"
            class="primary-color-reset"
            (click)="resetToDefault(); $event.preventDefault(); $event.stopPropagation()">
            Reset
        </button>
    }
</label>
